$(function () {

  $("#enventFiveTBtn").click(function () {
    $(".yuyue").show();
  });
  $("#enventFiveBBtn").click(function () {
    $(".yuyue").show();
  });
  new Swiper("#schoolBox", {
    autoplay: {
        delay: 3000,
        disableOnInteraction: true
    },
    loop: true,
    pagination: {
      el: ".enventThree_pagination",
      clickable: true,
    },
  });

  new Swiper("#youhui", {
    autoplay: {
        delay: 3000,
        disableOnInteraction: true
    },
    loop: true,
    pagination: {
      el: ".youhui_pagination",
      clickable: true,
    },
  });
  new Swiper("#book", {
    autoplay: {
        delay: 3000,
        disableOnInteraction: true
    },
    loop: true,
    pagination: {
      el: ".book_pagination",
      clickable: true,
    },
  });
  var cityOptions = [
    { text: "北京市" },
    { text: "天津市" },
    { text: "上海市" },
    { text: "重庆市" },
    { text: "河北省" },
    { text: "河南省" },
    { text: "广东省" },
    { text: "辽宁省" },
    { text: "湖南省" },
    { text: "四川省" },
    { text: "安徽省" },
    { text: "山东省" },
    { text: "江苏省" },
    { text: "浙江省" },
    { text: "湖北省" },
    { text: "山西省" },
    { text: "陕西省" },
    { text: "福建省" },
    { text: "江西省" },
    { text: "广西省" },
    { text: "甘肃省" },
    { text: "黑龙江省" },
    { text: "内蒙古" },
    { text: "吉林省" },
    { text: "新疆维吾尔" },
    { text: "贵州省" },
    { text: "云南省" },
    { text: "青海省" },
    { text: "西藏" },
    { text: "宁夏回族" },
    { text: "海南省" },
  ];
  var courseOptions =[
    {text:"雅思"},
    {text:"托福"},
    {text:"sat"}
  ]
  var index = {
    submit2: function submit2() {
      $(".alert-icon").click(function () {
        $(".common-alert").hide();
      });
     
      new Bselector({
        showSelected: "#cityName02",
        inputSelected: "#inputCity02",
        options: cityOptions,
      });
      $(".enventSix_form").listenForm({
        contentName: [
          {
            search: "?jtppzq",
            name: "web雅思节领书（百品）",
          },
          {
            search: "?360jtppzq",
            name: "  web雅思节领书（3品）",
          },
          {
            search: "?tg",
            name: "  web雅思节领书（原生）",
          },
          {
            search: "",
            name: "web雅思节领书",
          },
        ],
        submitTarget: ".yuyue_btn",
        isMsg: true,
        smsInfo:
          "【新航道】新航道烤鸭大礼包领取链接: https://pan.baidu.com/s/1Fm84dZaGjzO8Twu-BL-m9A 提取码: jsen 复制这段内容后打开百度网盘手机App，操作更方便哦。",
        cityRequired: true,
        successFun: function successFun() {
          $(".alert-bg").show();
        },
      });
    },
    timeLess: function timeLess() {
      function show_time() {
        var time_start = new Date().getTime(); //设定当前时间

        var time_end = new Date("2020/5/10 00:00:00").getTime(); // 计算时间差

        var time_distance = time_end - time_start;

        if (time_distance > 0) {
          // 天
          var int_day = Math.floor(time_distance / 86400000);
          time_distance -= int_day * 86400000; // 时

          var int_hour = Math.floor(time_distance / 3600000);
          time_distance -= int_hour * 3600000; // 分

          var int_minute = Math.floor(time_distance / 60000);
          time_distance -= int_minute * 60000;
          var int_second = Math.floor(time_distance / 1000);

          if (int_day < 10) {
            int_day = "0" + int_day;
          }

          if (int_hour < 10) {
            int_hour = "0" + int_hour;
          }

          if (int_minute < 10) {
            int_minute = "0" + int_minute;
          }

          if (int_second < 10) {
            int_second = "0" + int_second;
          }

          $("#time_d").val(int_day);
          $("#time_h").val(int_hour);
          $("#time_m").val(int_minute);
          $("#time_s").val(int_second);
        } else {
          $("#time_d").val("00");
          $("#time_h").val("00");
          $("#time_m").val("00");
          $("#time_s").val("00");
          window.clearInterval(interval);
        }
      }

      var interval = setInterval(show_time, 1000);
    },
    submit3:function submit3(){
      $(".guanbi").click(function () {
        $(".yuyue").hide();
      });
      new Bselector({
        showSelected: "#cityName",
        inputSelected: "#cityInput",
        options: cityOptions,
      });
      new Bselector({
        showSelected: "#courseName",
        inputSelected: "#courseInput",
        options: courseOptions,
      });
      $(".yuyue").listenForm({
        contentName: [
          {
            search: "?jtppzq",
            name: "web雅思节弹窗（百品）",
          },
          {
            search: "?360jtppzq",
            name: "  web雅思节弹窗（3品）",
          },
          {
            search: "?tg",
            name: "  web雅思节弹窗（原生）",
          },
          {
            search: "",
            name: "web雅思节弹窗",
          },
        ],
        submitTarget: ".free-btn",
        cityRequired: true,
        courseRequired: true,
      });
    },
    init: function init() {
      this.timeLess();
      this.submit2();
      this.submit3();
    },
  };

  index.init();
  $('.baoming').click(function () {
    var top1 = $('.enventFiveB').offset().top;
    $('html,body').animate({
      scrollTop: top1
    });
  });
});
